import script from "./DialogAutoMonitor.vue?vue&type=script&setup=true&lang=ts"
export * from "./DialogAutoMonitor.vue?vue&type=script&setup=true&lang=ts"

import "./DialogAutoMonitor.vue?vue&type=style&index=0&id=19cd91f9&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-19cd91f9"]])

export default __exports__